import type { IconSvgObject } from './types';

const ArchiveRestoreIcon: IconSvgObject = [
  ["path", { d: "M20 8V19C20 20.1046 19.1046 21 18 21H16M4 8V19C4 20.1046 4.89543 21 6 21H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 3H3C2.44772 3 2 3.44772 2 4V7C2 7.55228 2.44772 8 3 8H21C21.5523 8 22 7.55228 22 7V4C22 3.44772 21.5523 3 21 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 15L12 12L9 15M12 12.5V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArchiveRestoreIcon;
